import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './material-dashboard'
import store from './store'
import { Pagination } from '@/components'
import Vuelidate from 'vuelidate'
// Plugins
import App from './App.vue'
import Chartist from 'chartist'
import VueMask from 'v-mask'

// router setup
import routes from './routes/routes'

// plugin setup
Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(DashboardPlugin)
Vue.use(VueMask)

Vue.component(Pagination)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkExactActiveClass: 'nav-item active'
})

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
  get() {
    return this.$root.Chartist
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      console.log('No está logueado')
      store.commit('setDashboardMode', false)
      next({
        name: 'Login'
      })
    } else {
      store.commit('setDashboardMode', true)
      if (
        to.matched.some(record => record.name === 'calendar') &&
        (store.state.role_id == 2 || store.state.role_id == 1)
      ) {
        next({
          name: 'calendarmultiple'
        })
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.loggedIn) {
      store.commit('setDashboardMode', true)
      //next();
      if (store.state.role_id === 2) {
        next({
          path: '/CalendarMultiple'
        })
      } else {
        next({
          path: '/Calendar'
        })
      }
    } else {
      store.commit('setDashboardMode', false)
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data() {
    return {
      Chartist: Chartist
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.handleResize()
      })
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.$store.commit('SET_WINDOW_SIZE', window)
    }
  },
  render: h => h(App),
  router,
  store
})
